var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemitrailer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.7 62.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.3,42h36.8s2.2-.2,2.3-2.5V4.2l-.4-1.2c-.8-1-1.8-1.4-3.3-1.3-3.5.2-7,0-10.5,0H4.4c-1.5,0-2.8,1.3-2.8,2.8v39.8c0,2.9.6,2.7,1.5,3.7,1.8,1.7,3.5,3.5,5.2,5.2s2.4,1.6,3.9,1.6h6.7c1.9,0,2.8-.9,2.8-2.8s-.3-.9-1-.9h-7.9c-2.7,0-1.7-.3-2.4-1l-4.5-4.5c-.5-.5-.7-1.1-.7-1.8V6.6c0-.9.2-1.3,1.1-1.3h151.1c.8,0,1.5.7,1.5,1.5v22c0,.5,0,1,0,1.5v6.7c0,.9-1.1,1.1-1.1,1.1h-38c-2.8,0-2.5.5-3.3,1.4-2.9,2.9-5.9,5.7-8.6,8.7-1.8,2-3.6,3.2-6.4,2.7,0,0-17.4,0-17.4.2v2.4c0,.9.2,1.1,1.1,1.1h19.3c2.7,0,2.9-.6,4-1.7l10.5-10.5c.5-.5,1.7-.7,1.7-.7,0,0,2.6.3,2.6.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.8,43.9c-5.1,0-9.1,4.1-9.1,9.1s4.1,9.2,9.2,9.2,9.1-4.1,9.2-9.1c0-5.1-4.1-9.2-9.2-9.2h0ZM72.8,58.5c-3,0-5.5-2.4-5.5-5.4s2.4-5.5,5.5-5.5,5.5,2.5,5.5,5.5-2.4,5.4-5.5,5.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.4,44.5c-3.7,1.3-6,4.8-5.9,8.8,0,3.7,2.5,7.1,5.8,8.2,1,.5,2.1.7,3.3.6h.5c3.8-.3,6.6-2.2,8-5.7,1.5-3.6.8-7-1.9-9.8s-6.1-3.5-9.8-2.2h0ZM52.6,58.5c-3,0-5.4-2.5-5.4-5.5s2.5-5.5,5.6-5.4c3,0,5.4,2.5,5.4,5.5s-2.4,5.4-5.5,5.4h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.4,46c-3.2-2.7-7.8-2.9-11.1-.5-.9.5-1.6,1.3-2.2,2.2-.1.2-.3.4-.4.6-1.1,1.7-1.5,3.5-1.3,5.5.2,4,3.3,7.4,7.4,8.2,4,.8,8.2-1.3,10-5.1,1.8-3.7.8-8.3-2.4-10.9ZM27.8,50.1c.6-.8,1.1-1.5,2.2-2,2.9-1,5.1-.5,6.7,1.4s1.6,3.1,1.1,4.8c-1,3.8-5.2,5.2-8.2,3.3-2.3-1.5-3.2-4.3-2.1-6.8,0-.2.2-.5.3-.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemitrailer2);
export default __webpack_public_path__ + "static/media/semitrailer2.3d4b6412a88dc109641cd990eb73a281.svg";
export { ForwardRef as ReactComponent };